import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";

const resourceToBackendConfig = resourcesToBackend(
  (language, namespace, callback) => {
    const importByNamespace: { [key: string]: () => Promise<any> } = {
      core: () => import(`../../core/translations/${language}.json`),
      default: () =>
        import(`../../${namespace}/translations/${language}.json`).catch(() => {
          return import(
            `../features/${namespace}/translations/${language}.json`
          );
        }),
    };

    const importPromise = (
      importByNamespace[namespace] || importByNamespace.default
    )();

    importPromise
      .then((resources) => {
        callback(null, resources.default);
      })
      .catch((error) => {
        callback(error, null);
      });
  },
);

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .use(resourceToBackendConfig)
  .init({
    fallbackLng: "pt_BR",
    supportedLngs: ["pt_BR", "es_MX", "en_US"],
    defaultNS: "core",
    fallbackNS: ["core"],
    ns: ["core"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      transSupportBasicHtmlNodes: true,
    },
    debug: false,
  });

/**
 * Nossos códigos de idioma usam "_" (pt_BR), mas `Intl.PluralRules` só aceita
 * tags BCP-47 com "-" (pt-BR) — com "_" ele lança e o resolver do i18next cai
 * silenciosamente sem nenhuma regra, então sufixos `_one`/`_other` nunca são
 * escolhidos e toda chave pluralizada sempre usa a forma base (plural).
 * Normalizar aqui é mais seguro que trocar `supportedLngs`/nomes de arquivo
 * para "-", que tocaria o app inteiro.
 */
const originalGetRule = i18n.services.pluralResolver.getRule.bind(
  i18n.services.pluralResolver,
);
i18n.services.pluralResolver.getRule = (code: string, options: unknown) => {
  try {
    return new Intl.PluralRules(
      code.replace("_", "-"),
      options as Intl.PluralRulesOptions,
    );
  } catch {
    return originalGetRule(code, options as never);
  }
};

export default i18n;
